<template>
  <div>
    <van-nav-bar left-text="返回" left-arrow @click-left="onClickLeft" />
    <div class="menu_style">
      <van-form>
        <div>
          <van-field v-model="familyVO.firstName" label="姓" />
          <van-field v-model="familyVO.lastName" label="名" />
        </div>
        <div style="margin-top: 11px">
          <van-field
            readonly
            clickable
            :value="familyVO.sex"
            label="性别"
            @click="sex_show = true"
          />
          <van-popup
            v-model="sex_show"
            round
            position="bottom"
            :style="{ height: '40%' }"
          >
            <van-picker
              title="性别"
              show-toolbar
              :columns="sex_columns"
              @confirm="sex_confirm"
              @cancel="sex_cancel"
            />
          </van-popup>
          <van-field
            readonly
            clickable
            :value="familyVO.born"
            label="出生日期"
            @click="born_show = true"
          />
          <van-popup
            v-model="born_show"
            round
            position="bottom"
            :style="{ height: '40%' }"
          >
            <van-datetime-picker
              v-model="currentDate"
              type="date"
              title="选择出生日期"
              :min-date="minDate"
              @confirm="born_confirm"
              @cancel="born_cancel"
          /></van-popup>
          <!-- <div class="sex_style">
            <div>性别</div>
            <van-radio-group v-model="familyVO.sex">
              <van-radio class="man_style" name="男">男</van-radio>
              <van-radio name="女">女</van-radio>
            </van-radio-group>
          </div> -->
          <van-field
            v-model="familyVO.cardId"
            label="身份证"
            placeholder="(通关需要)"
          />
        </div>

        <div style="margin-top: 11px">
          <van-field
            readonly
            clickable
            :value="familyVO.height"
            label="身高（cm）"
            @click="height_show = true"
          />
          <van-popup
            v-model="height_show"
            round
            position="bottom"
            :style="{ height: '40%' }"
          >
            <van-picker
              title="身高（cm）"
              show-toolbar
              :columns="height_columns"
              @confirm="height_confirm"
              @cancel="height_cancel"
            />
          </van-popup>

          <van-field
            readonly
            clickable
            :value="familyVO.weight"
            label="体重（kg）"
            @click="weight_show = true"
          />
          <van-popup
            v-model="weight_show"
            round
            position="bottom"
            :style="{ height: '40%' }"
          >
            <van-picker
              title="体重（kg）"
              show-toolbar
              :columns="weight_columns"
              @confirm="weight_confirm"
              @cancel="weight_cancel"
            />
          </van-popup>
        </div>
        <div style="margin-top: 11px">
          <van-field
            readonly
            clickable
            :value="familyVO.immunity"
            label="免疫力"
            @click="immunity_show = true"
          />
          <van-popup
            v-model="immunity_show"
            round
            position="bottom"
            :style="{ height: '40%' }"
          >
            <van-picker
              title="免疫力"
              show-toolbar
              :columns="immunity_columns"
              @confirm="immunity_confirm"
              @cancel="immunity_cancel"
            />
          </van-popup>

          <van-field
            readonly
            clickable
            :value="familyVO.allergy"
            label="过敏"
            @click="allergy_show = true"
          />
          <van-popup
            v-model="allergy_show"
            round
            position="bottom"
            :style="{ height: '40%' }"
          >
            <van-picker
              title="过敏"
              show-toolbar
              :columns="allergy_columns"
              @confirm="allergy_confirm"
              @cancel="allergy_cancel"
            />
          </van-popup>
          <van-field
            v-model="familyVO.disease"
            rows="4"
            autosize
            label="病史"
            type="textarea"
            maxlength="100"
            show-word-limit
          />
        </div>
        <div style="margin-top: 40px">
          <van-button block type="danger" @click="family_save_click"
            >完成</van-button
          >
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { Toast } from "vant";
export default {
  computed: {
    ...mapState(["cgmUserVO"]),
  },
  data() {
    return {
      sex_show: false,
      sex_columns: ["男", "女"],
      born_show: false,
      minDate: new Date(1950, 0, 1),
      currentDate: new Date(1980, 0, 1),
      height_show: false,
      weight_show: false,
      immunity_show: false,
      allergy_show: false,
      familyVO: {
        userId: null,
        firstName: null,
        lastName: null,
        born: null,
        sex: null,
        cardId: null,
        height: null,
        weight: null,
        immunity: null,
        allergy: null,
        disease: null,
      },
      height_columns: [
        "100",
        "110",
        "120",
        "130",
        "140",
        "150",
        "160",
        "170",
        "180",
        "190",
        "200",
      ],
      weight_columns: [
        "30",
        "40",
        "50",
        "60",
        "70",
        "80",
        "90",
        "100",
        "110",
        "120",
        "130",
        "140",
      ],
      immunity_columns: ["低", "中", "高"],
      allergy_columns: [
        "坚果",
        "鱼虾",
        "贝类",
        "花生",
        "牛奶",
        "鸡蛋",
        "大豆",
        "小麦",
        "其他",
      ],
    };
  },
  mounted() {},
  methods: {
    family_save_click() {
      let userId = JSON.parse(this.cgmUserVO).userId;
      this.familyVO.userId = userId;
      if (this.familyVO.firstName == null || this.familyVO.firstName == "") {
        Toast.success("请填写姓");
        return;
      }
      if (this.familyVO.lastName == null || this.familyVO.lastName == "") {
        Toast.success("请填写名");
        return;
      }
      if (this.familyVO.sex == null || this.familyVO.sex == "") {
        Toast.success("请选择性别");
        return;
      }
      if (this.familyVO.born == null || this.familyVO.born == "") {
        Toast.success("请选择出生日期");
        return;
      }

      this.axios.post("/cgmFamily/save", this.familyVO).then((res) => {
        if (res.data.code == 200) {
          this.$router.push({
            path: "/menu",
          });
          Toast.success("已添加");
        }
      });
    },
    sex_confirm(v) {
      this.familyVO.sex = v;
      this.sex_show = false;
    },
    born_confirm() {
      this.familyVO.born = this.timeFormat(this.currentDate);
      this.born_show = false;
    },
    timeFormat(time) {
      let year = time.getFullYear();
      let month = String(time.getMonth() + 1).padStart(2, "0");
      let day = String(time.getDate()).padStart(2, "0");
      return year + "-" + month + "-" + day;
    },
    height_confirm(v) {
      this.familyVO.height = v;
      this.height_show = false;
    },
    weight_confirm(v) {
      this.familyVO.weight = v;
      this.weight_show = false;
    },
    immunity_confirm(v) {
      this.familyVO.immunity = v;
      this.immunity_show = false;
    },
    allergy_confirm(v) {
      this.familyVO.allergy = v;
      this.allergy_show = false;
    },
    sex_cancel() {
      this.sex_show = false;
    },
    born_cancel() {
      this.born_show = false;
    },
    height_cancel() {
      this.height_show = false;
    },
    weight_cancel() {
      this.weight_show = false;
    },
    immunity_cancel() {
      this.immunity_show = false;
    },
    allergy_cancel() {
      this.allergy_show = false;
    },
    onClickLeft() {
      this.$router.push({
        path: "/menu",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .van-radio--horizontal {
  margin-right: unset !important;
}
::v-deep .van-field__control {
  text-align: right !important;
}
.sex_style {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  color: #646566;
  font-size: 14px;
  line-height: 24px;
  background: #fff;
}
.man_style {
  margin-bottom: 4px;
}
.menu_style {
  background: #f5f6f8;
  padding: 19px 15px 45px 15px;
}
.card_style1 {
  background: #fff;
  border-radius: 10px;
  margin-bottom: 45px;
}
.layout_style {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 10px 20px 10px;
}
.border_style {
  border-bottom: 1px solid #e5e9f0;
}
.title_style {
  color: #202f3b;
  font-size: 16px;
  font-weight: bold;
}
</style>